module.exports = __webpack_public_path__ + "img/materia.dc1d34ec.png";